import { render, staticRenderFns } from "./LeadStatusTag.vue?vue&type=template&id=5a32b302&scoped=true"
import script from "./LeadStatusTag.vue?vue&type=script&lang=js"
export * from "./LeadStatusTag.vue?vue&type=script&lang=js"
import style0 from "./LeadStatusTag.vue?vue&type=style&index=0&id=5a32b302&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a32b302",
  null
  
)

export default component.exports